import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { NAV } from './nav';
import { SearchProvider, useSearch } from './search';
import { GoogleReturnNotice } from '@/components/crm/GoogleConnect';
import { useUpdateAvailable } from '@/lib/updateCheck';
import { PhoneProvider } from '@/phone/PhoneProvider';

function titleFor(pathname: string): string {
  if (pathname.startsWith('/deals/')) return 'Pipeline';
  if (pathname.startsWith('/settings')) return 'Settings';
  // Longest matching nav path wins.
  const match = [...NAV]
    .sort((a, b) => b.path.length - a.path.length)
    .find((n) => (n.path === '/' ? pathname === '/' : pathname.startsWith(n.path)));
  return match?.label ?? 'clientIQ';
}

function AppShellInner() {
  const { pathname } = useLocation();
  const { setQuery } = useSearch();
  const [navOpen, setNavOpen] = useState(false);
  const updateAvailable = useUpdateAvailable();

  // Reset the search box and close the mobile nav when navigating between pages.
  useEffect(() => {
    setQuery('');
    setNavOpen(false);
  }, [pathname, setQuery]);

  return (
    <div className="dash">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="dash-main">
        <Topbar title={titleFor(pathname)} onMenu={() => setNavOpen(true)} />
        {updateAvailable && (
          <div className="dash-update" role="status">
            <span>clientIQ was updated since this tab opened.</span>
            <button type="button" onClick={() => window.location.reload()}>Reload to get the latest</button>
          </div>
        )}
        <div className="dash-body">
          <GoogleReturnNotice />
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export function AppShell() {
  return (
    <SearchProvider>
      <PhoneProvider>
        <AppShellInner />
      </PhoneProvider>
    </SearchProvider>
  );
}
